<script>
  let { src } = $props();
</script>

<img src="{src}" alt="" />